export default {"src":"/uk/_next/static/media/podcastIcon.48e1d2dd.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};